import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from "react-router-dom";
import SessionContext from "SessionContext";
import ProgressLoader from '../partials/progress-loader';
import FormatDateTime from "core/utils/FormatDateTime";

function ModelStatus() {
  const location = useLocation();
  const session = useContext(SessionContext);
  const access = session.appState.userCan;

  const {id} = location.state;
  const [modelInfo, setModelInfo] = useState({name: "", status: ""});
  const [modelLogs, setModelLogs] = useState([]);
  const [modelErrors, setModelErrors] = useState("");
  const [sortedDown, setSortedDown] = useState(false);

  useEffect(() => {
    if (id) {
      session.query("model/get", { id: id })
             .then((response) => {
                setModelInfo({name: response.name, status: response.status});
             })
             .catch ((error) => {
               console.log("/model/get failed. ", error);
             });

      session.query("model/getlog", { id: id })
              .then((response) => {
                if(response.id !== null) {
                  setModelLogs(response.logs.reverse());
                  setModelErrors(response.error_text);
                }
              })
              .catch ((error) => {
                console.log("/getlog failed. ", error);
              });
    }
    // eslint-disable-next-line
  }, [id])

  const onHandleSort = () => {
    const sorted = [...modelLogs];
    setModelLogs(sorted.reverse());
    setSortedDown(!sortedDown);
  };
 
  return (
    <div className="page">
      <div className="list-header sticky-page-header">
        <Link to="/models">
          <button type="button" className="new-button">
            <i className="bi bi-chevron-left"></i> Models
          </button>
        </Link>
        <h1>Model Status</h1>
        <i className="spacer" />
      </div>

      {modelInfo.name ? (
        <section className="order-status-main">
          <div className="status-header">
            <h5>Model Name: <span>{modelInfo.name}</span></h5>
            <h5>Model Status: <span>{modelInfo.status}</span></h5>
          </div>
          <div className="status-body">
            <div className="flex-status-col">
              <div className="history">
                <h6>Model  History</h6>
                <button className="sort-btn" onClick={onHandleSort}>
                  {sortedDown ? <i className="bi bi-sort-down" /> : <i className="bi bi-sort-up-alt" />}
                </button>
              </div>
              {modelLogs && modelLogs.length ? 
                <div className="status-list">
                  {modelLogs.map((log) => <StatusLogs log={log} key={log.message} />)}
                </div>
              : <div>No history found.</div>}
            </div>

            <div className="flex-error-col">
              <h6>Model Errors</h6><br />
              {
                modelErrors && modelErrors.length ? 
                <StatusError error={modelErrors} access={access} id={id} /> : 
                <div>No errors found.</div>
              }
            </div>
          </div>
        </section>
        ) : <StatusLoading />
      }
      
    </div>
  )
}

export default ModelStatus;

const StatusLogs = ({ log }) => {
  return (
    <div className="status-card">
      <div>
        <FormatDateTime date={log.datetime} />
        <span>: </span>
        <span>
          <b>{log.message}</b>
        </span>
      </div>
    </div>
  );
};

/**
 * @returns the raw error for admins, or a message with an email link for all others
 */
const StatusError = ({error, access, id}) => {
  return (
    <div className="error-card">
      {access('administration') ? error : 
      <span>There was an error processing your model. Please reach out to Customer Success at <a href={`mailto:audiencemaker@speedeondata.com?subject=Model # ${id}`} rel="noreferrer">audiencemaker@speedeondata.com</a> for assistance.</span>}
    </div>
  );
};

const StatusLoading = () => {
  return (
    <section className="order-status-main">
      <div className="status-loading">
        <div className="loader-wrapper"><ProgressLoader /></div>
        <div className="text-wrapper">Loading...</div>
      </div>
    </section>
  );
};

